// Validation status of individual validations
export enum IndividualValidationStatus {
  Success,
  Warning,
  Error,
}
